/* Nordic Park — site behaviour tracking (2026-10-23, Ollie).
   Records what shoppers do on the storefront so the dashboard can show where Meta visitors drop out and which
   actions go with buying. Rows go straight to Supabase (table site_events, insert-only anon key; see
   nordic-park-dashboard/scripts/sql/site-events.sql). Checkout steps come from the Shopify custom pixel, which reads
   the same np_vid cookie. Orders carry the visitor id and where each product was found as hidden cart attributes
   (_npv, _nps), so purchases can be joined back to visits without the pixel.
   Loads deferred, listens at document level (no edits to other theme files), batches rows and sends them every
   10 s and when the page is hidden. Nothing here changes what shoppers see. */
(function () {
  if (window.__npt) return;
  window.__npt = 1;
  var C = window.NPT_CFG || {};
  if (!C.url || !C.key || C.key.indexOf('PASTE') === 0) return;
  var ua = navigator.userAgent || '';
  if (navigator.webdriver || /bot|crawl|spider|slurp|headless|lighthouse|pagespeed|facebookexternalhit|bingpreview|ptst/i.test(ua)) return;

  var doc = document, html = doc.documentElement;
  var meta = (window.ShopifyAnalytics && ShopifyAnalytics.meta) || {};
  var pageType = (meta.page && meta.page.pageType) || '';
  var role = window.Shopify && Shopify.theme && Shopify.theme.role;
  var TEST = role !== 'main' || /preview_theme_id|np_test=1/.test(location.search) || readCookie('np_test') === '1';
  // a browser forced into a split-test group (?np_ab=…, kept in localStorage) is ours: test from its first event
  try { Object.keys(localStorage).forEach(function (k) { if (/^np_abf_/.test(k) && /^[AB]$/.test(localStorage.getItem(k))) TEST = true; }); } catch (e) {}
  if (/[?&]np_ab=[^&:]+(:|%3A)[AB]/i.test(location.search)) TEST = true;
  if (TEST) writeCookie('np_test', '1', 1);

  /* ── ids ── */
  function readCookie(n) { var m = doc.cookie.match('(?:^|; )' + n + '=([^;]*)'); return m ? decodeURIComponent(m[1]) : null; }
  function writeCookie(n, v, days) { doc.cookie = n + '=' + encodeURIComponent(v) + '; path=/; max-age=' + days * 86400 + '; SameSite=Lax; Secure'; }
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function rid() { return Date.now().toString(36) + Math.random().toString(36).slice(2, 10); }

  var vid = readCookie('np_vid') || ls('np_vid');
  var returning = !!vid;
  if (!vid) vid = rid();
  writeCookie('np_vid', vid, 400);
  ls('np_vid', vid);

  var now = Date.now(), last = +(ss('np_slast') || 0), sid = ss('np_sid');
  var newSession = !sid || now - last > 30 * 60 * 1000;
  if (newSession) { sid = rid(); ss('np_sid', sid); }
  ss('np_slast', String(now));

  /* ── sending ── */
  var q = [], lastAct = null;
  function clean(v) { return typeof v === 'string' ? v.replace(/[\u0000\uD800-\uDFFF]/g, '') : v; }
  function track(ev, props) {
    if (props) Object.keys(props).forEach(function (k) { props[k] = clean(props[k]); });
    q.push({ ts: new Date().toISOString(), vid: vid, sid: sid, ev: ev, path: clean(location.pathname).slice(0, 300), props: props || null, test: TEST });
    if (!/^(page_end|perf|atc_seen|reviews_seen|faq_seen|session_start|page_view|geo|ab)$/.test(ev)) lastAct = ev + (props && props.v ? ':' + props.v : '');
    ss('np_slast', String(Date.now()));
    if (q.length >= 25) flush();
  }
  function flush() {
    if (!q.length) return;
    var rows = q.splice(0, q.length);
    try {
      fetch(C.url + '/rest/v1/site_events', {
        method: 'POST', keepalive: true,
        headers: { apikey: C.key, Authorization: 'Bearer ' + C.key, 'Content-Type': 'application/json', Prefer: 'return=minimal' },
        body: JSON.stringify(rows)
      }).catch(function () {});
    } catch (e) {}
  }
  setInterval(flush, 10000);
  window.npTrack = track;   // for other theme scripts and for testing

  /* ── session context: once per session ── */
  var sp = new URLSearchParams(location.search);
  if (newSession) {
    var ref = '';
    try { ref = doc.referrer ? new URL(doc.referrer).hostname : ''; } catch (e) {}
    if (ref === location.hostname) ref = '';
    track('session_start', {
      returning: returning, ref: ref.slice(0, 60),
      src: (sp.get('utm_source') || '').slice(0, 40), med: (sp.get('utm_medium') || '').slice(0, 40),
      camp: (sp.get('utm_campaign') || '').slice(0, 80), ad: (sp.get('utm_content') || sp.get('ad_id') || '').slice(0, 80),
      term: (sp.get('utm_term') || '').slice(0, 80), fbclid: sp.has('fbclid'),
      inapp: /FBAN|FBAV|FB_IAB/.test(ua) ? 'facebook' : /Instagram/.test(ua) ? 'instagram' : '',
      w: screen.width, h: screen.height, mobile: /Mobi|Android|iPhone/.test(ua), landing: pageType,
      tz: (function () { try { return Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) { return ''; } })(),
      lang: (navigator.language || '').slice(0, 10)
    });
  }

  /* country: Shopify's customer-privacy API knows the visitor's region from their IP (e.g. "USCA", "GBENG").
     It loads alongside this script, so wait for it; sent once per session. */
  if (!ss('np_geo')) {
    var tries = 0;
    (function geo() {
      var cp = window.Shopify && Shopify.customerPrivacy, r = '';
      try { r = cp && cp.getRegion ? cp.getRegion() || '' : ''; } catch (e) {}
      if (r || ++tries > 20) {
        ss('np_geo', '1');
        track('geo', { cc: r.slice(0, 2), region: r.slice(0, 8), mcc: (window.Shopify && Shopify.country) || '' });
        return;
      }
      setTimeout(geo, 500);
    })();
  }

  /* ── page view ── */
  var handle = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || '';
  var coll = (location.pathname.match(/\/collections\/([^/?#]+)/) || [])[1] || '';
  var pv = { type: pageType };
  if (handle) {
    pv.h = handle;
    pv.pid = meta.product && meta.product.id;
    var from = {};
    try { from = JSON.parse(ss('np_from') || '{}'); } catch (e) {}
    pv.from = from[handle] || (newSession ? (sp.has('fbclid') || /facebook|instagram/i.test(sp.get('utm_source') || '') ? 'ad' : 'landing') : refType());
    var src = {};
    try { src = JSON.parse(ls('np_src') || '{}'); } catch (e) {}
    src[handle] = pv.from;
    var hs = Object.keys(src); if (hs.length > 50) hs.slice(0, hs.length - 50).forEach(function (h) { delete src[h]; });   // keep the 50 latest
    ls('np_src', JSON.stringify(src));
  }
  if (coll) { pv.c = coll; pv.page = +(sp.get('page') || 1); }
  if (pageType === 'searchresults') pv.q = (sp.get('q') || '').slice(0, 80);
  track('page_view', pv);
  function refType() {
    var r = doc.referrer || '';
    if (r.indexOf(location.hostname) === -1) return 'external';
    if (/\/search/.test(r)) return 'search';
    if (/\/collections\//.test(r)) return 'collection';
    if (/\/products\//.test(r)) return 'product';
    return /\.co\/?(\?|$)/.test(r) ? 'home' : 'other';
  }

  /* ── split tests (23 Oct 2026) ──
     NPT_CFG.tests = { reviews_up: { on: true } } runs a test. Each visitor gets A or B from a hash of their visitor id
     (50/50, the same on every visit from this browser), sends one `ab` event per session, and their orders carry the
     group in the hidden cart attribute _npx.  { on: false } = everyone sees A, nothing is tracked.
     { on: false, winner: 'B' } = everyone sees B (the test is over), nothing is tracked.
     ?np_ab=reviews_up:B forces a group in this browser for checking, even when the test is off (marks it a test
     visitor); ?np_ab=reviews_up:off clears that. */
  var TESTS = C.tests || {}, groups = {};
  var EFFECTS = {
    // B: the reviews section above "Why Nordic Park" (video + 20,000 homes) on product pages. Both sections sit far
    // below the first screen and this runs before the page is shown, so nothing visibly jumps.
    reviews_up: function () {
      if (pageType !== 'product') return;
      var w = doc.querySelector('section.np-why'), r = doc.querySelector('.npr-wrap');
      w = w && w.closest('.shopify-section'); r = r && r.closest('.shopify-section');
      if (w && r && w.parentNode === r.parentNode && (w.compareDocumentPosition(r) & 4)) w.parentNode.insertBefore(r, w);
    }
  };
  function hash(str) { var h = 2166136261; for (var i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = Math.imul(h, 16777619); } return h >>> 0; }
  // The low bit of that hash is the same for every test name, so a second test would copy reviews_up's groups exactly.
  // Tests after reviews_up mix the bits first (independent 50/50); reviews_up keeps its original split so nobody switches.
  function groupFor(name) {
    var h = hash(vid + ':' + name);
    if (name === 'reviews_up') return h % 2 ? 'B' : 'A';
    h ^= h >>> 16; h = Math.imul(h, 0x85ebca6b); h ^= h >>> 13; h = Math.imul(h, 0xc2b2ae35); h ^= h >>> 16;
    return (h >>> 31) ? 'B' : 'A';
  }
  var forced = (sp.get('np_ab') || '').split(':');
  if (forced[0] && TESTS[forced[0]]) {
    if (forced[1] === 'off') ls('np_abf_' + forced[0], '');
    else { ls('np_abf_' + forced[0], forced[1] === 'B' ? 'B' : 'A'); writeCookie('np_test', '1', 1); TEST = true; }
  }
  Object.keys(TESTS).forEach(function (name) {
    var cfg = TESTS[name] || {}, f = ls('np_abf_' + name), g;
    if (f === 'A' || f === 'B') g = f;
    else if (cfg.on) { var st = ls('np_ab_' + name); g = st === 'A' || st === 'B' ? st : groupFor(name); ls('np_ab_' + name, g); }
    else { if (cfg.winner === 'B' && EFFECTS[name]) { try { EFFECTS[name](); } catch (e) {} } return; }
    groups[name] = g;
    if (g === 'B' && EFFECTS[name]) { try { EFFECTS[name](); } catch (e) {} }
    if (ss('np_ab_sent_' + name) !== g) { ss('np_ab_sent_' + name, g); track('ab', { t: name, g: g }); }   // once per session per group
  });
  // send the page's first rows now: a visitor who closes the Instagram/Facebook browser straight away often fires no
  // pagehide, and would otherwise vanish with them
  setTimeout(flush, 0);
  function groupsAttr() { return Object.keys(groups).map(function (k) { return k + ':' + groups[k]; }).join(',').slice(0, 200); }

  /* ── click map ── */
  var GROUP = { medOpts: 'medium', shapeOpts: 'shape', frameOpts: 'frame', sizeOpts: 'size' };
  function txt(el) { return ((el && (el.getAttribute('aria-label') || el.innerText)) || '').replace(/\s+/g, ' ').trim().slice(0, 60); }
  function sel() { var s = doc.getElementById('npcAtcSel'); return s ? txt(s).replace(/^Your selection:\s*/, '') : ''; }
  function inside(t, s) { return t.closest ? t.closest(s) : null; }

  doc.addEventListener('click', function (e) {
    var t = e.target, el;
    if (!t || !t.closest) return;

    /* product page: configurator */
    if ((el = inside(t, '#npcRoot .opt'))) {
      var g = inside(el, '.opts');
      // the button holds badge / name / price / description on separate lines: keep the name and the price
      var lines = (el.innerText || '').split('\n').map(function (x) { return x.trim(); }).filter(Boolean);
      var price = (lines.filter(function (x) { return /[−-]?\$[\d,]+/.test(x); })[0] || '').match(/[−-]?\$[\d,]+/);
      price = price ? price[0] : '';
      var raw = (lines.filter(function (x) { return !/^(popular|new|best ?seller)$/i.test(x) && !/^[−-]?\$[\d,]+$/.test(x); })[0] || txt(el)).slice(0, 60);
      setTimeout(function () { track('option', { g: GROUP[g && g.id] || (g && g.id) || '', v: raw.replace(/[−-]?\$[\d,]+/, '').trim(), price: price, sel: sel() }); }, 250);
      return;
    }
    if (inside(t, '#atcBtn')) { track('atc', { v: sel(), sel: sel(), h: handle }); setTimeout(cartAttrs, 6000); return; }   // fallback; cart:update below is the main trigger
    if (inside(t, '.npc-szs-btn')) return track('size_guide');
    if (inside(t, '.np-faq-szlink')) return track('size_guide', { from: 'faq' });   // FAQ link to the size guide (2026-10-27)
    if (inside(t, '.npc-cmp-open')) return track('compare');
    if ((el = inside(t, '.npc-zm'))) return track('frame_zoom', { v: txt(el).replace(/^Enlarge\s+/, '') });
    if (inside(t, '.npc-wallcta')) return track(doc.documentElement.classList.contains('yw-b') ? 'your_wall_chip_tap' : 'wall_preview');   // 29 Oct: with Your Wall the pill opens the upload panel
    if (inside(t, '.vth')) { galHow = 'tap'; galHowAt = Date.now(); return; }            // gallery thumbnail: the image it opens is sent by watchGallery
    if (inside(t, '.npc-nav, .npc-dot')) { galHow = 'arrow'; galHowAt = Date.now(); return; }
    // Sample row (fixed 30 Oct 2026, audit item 2.12): the element is <details class="npc-smp" id="npcSmp">, and PDP v3 moves its
    // body into a cloned accordion row with class p3-smp-row — the old '.npcSmp' selector matched nothing (0 rows since launch).
    if ((el = inside(t, '#npcSmp button, #npcSmp a, .p3-smp-row button, .p3-smp-row a'))) return track('sample_click', { v: txt(el) });
    if ((el = inside(t, '.np-faq__question'))) { if (el.getAttribute('aria-expanded') !== 'true') track('faq_open', { v: txt(el) }); return; }
    if ((el = inside(t, 'summary'))) {
      var d = el.parentElement;
      d = el.closest('details') || d;
      if (d && (d.id === 'npcSmp' || (d.closest && d.closest('.p3-smp-row')))) { if (!d.open) track('sample_open'); return; }
      if (el.classList.contains('details__header') && d && !d.open) return track('accordion_open', { v: txt(el) });
    }
    if ((el = inside(t, '.npr-scope-btn'))) return track('reviews_scope', { v: el.getAttribute('data-scope') });
    if (inside(t, '#nprStripNext, .npr-strip-nav')) return track('review_photos_scroll');
    if ((el = inside(t, '[id*="np_reviews"] img'))) return track('review_photo_open');

    /* hearts: product page and cards; state is read after np-saved.js has toggled it */
    if ((el = inside(t, '.nps-heart'))) {
      setTimeout(function () { track(el.getAttribute('aria-pressed') === 'true' ? 'save' : 'unsave', { h: el.getAttribute('data-nps-handle'), where: el.classList.contains('nps-heart--pdp') ? 'pdp' : pageType }); }, 50);
      return;
    }
    if (inside(t, '.nps-open')) return track('saved_open');
    if ((el = inside(t, '#nps-dialog a[href*="/products/"]'))) { remember(el.getAttribute('href'), 'saved'); return track('saved_item_click'); }

    /* collection grid */
    if (inside(t, '.vg-arrow')) return track('card_view_swipe', { c: coll });
    if ((el = inside(t, 'a.v2c'))) {
      var cards = Array.prototype.slice.call(doc.querySelectorAll('a.v2c'));
      var pos = cards.indexOf(el) + 1, pg = +(sp.get('page') || 1);
      var src = pageType === 'collection' ? 'collection:' + coll : pageType === 'index' ? 'home' : pageType === 'product' ? 'recommended' : pageType;
      remember(el.getAttribute('href'), src);
      return track('card_click', { c: coll, pos: pos, page: pg, h: hFrom(el.getAttribute('href')), src: src });
    }
    if ((el = inside(t, '.v2f__medb'))) return track('collection_medium', { v: el.getAttribute('data-med'), c: coll });
    if ((el = inside(t, '.v2f__w'))) return track('filter_open', { v: el.getAttribute('data-facet') });
    if ((el = inside(t, '.v2g__pg'))) return track('collection_page', { v: txt(el), c: coll });

    /* header + menu */
    if (inside(t, '[data-testid="cart-drawer-trigger"]')) { cartAttrs(); return track('cart_open'); }
    if (inside(t, '.search-modal__button')) return track('search_open');
    if ((el = inside(t, 'header a[href], .menu-drawer a[href]'))) return track('menu', { v: (el.getAttribute('href') || '').slice(0, 80) });

    /* cart drawer */
    if (inside(t, 'cart-drawer-component, .cart-drawer')) {
      el = inside(t, 'button, a');
      if (!el) return;
      var lab = txt(el);
      if (/checkout/i.test(lab) || el.name === 'checkout') return track('checkout_click');
      if (/^remove/i.test(lab)) return track('cart_remove');
      if (/quantity/i.test(lab)) return track('cart_qty', { v: /increase/i.test(lab) ? 'up' : 'down' });
      if (/^add it$/i.test(lab)) return track('cart_code_open');
    }
  }, true);

  /* filter checkboxes */
  doc.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.name && t.name.indexOf('filter.') === 0) track('filter', { f: t.name.replace(/^filter\.(p\.m\.custom\.|v\.option\.|p\.)?/, '').slice(0, 30), v: (t.getAttribute('data-label') || t.value || '').slice(0, 40), on: !!t.checked, c: coll });
  }, true);

  /* product found where? kept per tab for the cart attribute */
  function hFrom(href) { var m = /\/products\/([^/?#]+)/.exec(href || ''); return m ? decodeURIComponent(m[1]) : ''; }
  function remember(href, src) {
    var h = hFrom(href); if (!h) return;
    var f = {}; try { f = JSON.parse(ss('np_from') || '{}'); } catch (e) {}
    f[h] = src; ss('np_from', JSON.stringify(f));
  }

  /* orders carry the visitor id and each carted product's source (hidden attributes, underscore = not shown to the shopper) */
  function cartAttrs() {
    var src = {}; try { src = JSON.parse(ls('np_src') || '{}'); } catch (e) {}
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var map = {};
      (cart.items || []).forEach(function (it) { if (src[it.handle]) map[it.handle] = src[it.handle]; });
      var want = { _npv: vid, _nps: JSON.stringify(map).slice(0, 900), _npx: groupsAttr() };
      var have = cart.attributes || {};
      if (have._npv === want._npv && have._nps === want._nps && (have._npx || '') === want._npx) return;
      return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: want }) });
    }).catch(function () {});
  }
  if (pageType === 'cart') cartAttrs();
  // the theme fires a bubbling cart:update after every successful cart change (configurator, quick add, drawer)
  var caT = 0;
  doc.addEventListener('cart:update', function () { clearTimeout(caT); caT = setTimeout(cartAttrs, 400); });

  /* gallery (24 Oct 2026): every image a visitor lands on, once per image per page view, with how they got there.
     The configurator builds the thumbnail strip (#viewThumbs) after load and marks the open image's thumbnail .vth.on
     on every change (tap, arrow or swipe), so watching that class catches all three. Each thumbnail's title names the
     image ("Product", "Up close", "The frame", "Size guide", "Product details", "Real homes", or a room's name). The
     image open when the page loads is not counted: everyone sees it. */
  var galHow = '', galHowAt = 0, galSeen = {};
  function thumbInfo(b) {
    var strip = b.parentElement, k = b.getAttribute('title') || '';
    return { i: Array.prototype.indexOf.call(strip.children, b) + 1, of: strip.children.length,
      kind: /^(Product|Product details|Size guide|The frame|Up close|Real homes)$/.test(k) ? k
        : k === 'See it on your wall' ? 'Your wall invite' : /^Your room/.test(k) ? 'Your wall' : 'Room' };   // Your Wall slides apart from mockups (2026-10-27)
  }
  function watchGallery(tries) {
    var strip = doc.getElementById('viewThumbs');
    if (!strip || !strip.querySelector('.vth')) { if (tries < 40) setTimeout(function () { watchGallery(tries + 1); }, 250); return; }
    var open = strip.querySelector('.vth.on');
    if (open) galSeen[thumbInfo(open).kind + thumbInfo(open).i] = 1;
    var last = open;
    new MutationObserver(function () {
      var on = strip.querySelector('.vth.on');
      if (!on || on === last) return;
      last = on;
      var x = thumbInfo(on), key = x.kind + x.i;
      if (galSeen[key]) return;
      galSeen[key] = 1;
      x.how = Date.now() - galHowAt < 1500 ? galHow : 'swipe';
      track('img', x);
    }).observe(strip, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
  }
  if (pageType === 'product' && window.MutationObserver) watchGallery(0);

  /* seen on screen: the add-to-cart button, reviews, FAQ */
  function seen(selector, ev) {
    var node = doc.querySelector(selector);
    if (!node || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (ents) {
      if (ents.some(function (x) { return x.isIntersecting; })) { track(ev); io.disconnect(); }
    }, { threshold: 0, rootMargin: '0px 0px -30% 0px' });   // seen = reached the top 70% of the screen (half of a tall section never fits on a phone)
    io.observe(node);
  }
  function watch() {
    // FAQ section: np_faq on the v2-config template, custom_liquid_cMHrnK on the others
    if (pageType === 'product') { seen('#atcBtn', 'atc_seen'); seen('[id*="np_reviews"]', 'reviews_seen'); seen('[id*="np_faq"], [id*="custom_liquid_cMHrnK"]', 'faq_seen'); }
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', watch); else watch();

  /* email popup (Klaviyo fires these on window); an email given is stored only as a SHA-256 hash */
  window.addEventListener('klaviyoForms', function (e) {
    var d = e.detail || {};
    if (/^(open|embedOpen|close|submit)$/.test(d.type || '')) track('popup_' + d.type, { form: (d.formId || '').slice(0, 20) });
    var em = d.metaData && (d.metaData.$email || d.metaData.email);
    if (d.type === 'submit' && em) identify(em, 'popup');
  });
  function identify(email, how) {
    try {
      var b = new TextEncoder().encode(String(email).trim().toLowerCase());
      crypto.subtle.digest('SHA-256', b).then(function (h) {
        var hex = Array.prototype.map.call(new Uint8Array(h), function (x) { return ('0' + x.toString(16)).slice(-2); }).join('');
        track('identify', { eh: hex, how: how });
      });
    } catch (e) {}
  }

  /* speed: largest image paint and time to first byte, as real phones saw them */
  var lcp = 0, cls = 0;
  try {
    new PerformanceObserver(function (l) { var es = l.getEntries(); if (es.length) lcp = es[es.length - 1].startTime; }).observe({ type: 'largest-contentful-paint', buffered: true });
    new PerformanceObserver(function (l) { l.getEntries().forEach(function (x) { if (!x.hadRecentInput) cls += x.value; }); }).observe({ type: 'layout-shift', buffered: true });
  } catch (e) {}

  /* leaving: time on page, how far down, last thing done */
  var t0 = Date.now(), maxScroll = 0, ended = false, perfSent = false;
  var scrollRaf = 0;
  addEventListener('scroll', function () {
    if (scrollRaf) return;
    scrollRaf = requestAnimationFrame(function () {
      scrollRaf = 0;
      var h = Math.max(1, html.scrollHeight - innerHeight);
      maxScroll = Math.max(maxScroll, Math.min(100, Math.round(100 * scrollY / h)));
    });
  }, { passive: true });
  function end() {
    if (ended) return;
    ended = true;
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (!perfSent) { perfSent = true; track('perf', { lcp: Math.round(lcp), ttfb: nav ? Math.round(nav.responseStart) : null, cls: Math.round(cls * 1000) / 1000 }); }
    track('page_end', { s: Math.round((Date.now() - t0) / 1000), scroll: maxScroll, last: lastAct });
    flush();
  }
  addEventListener('pagehide', end);
  doc.addEventListener('visibilitychange', function () {
    if (doc.visibilityState === 'hidden') end(); else if (ended) { ended = false; t0 = Date.now(); }
  });
})();
